import Box from "@mui/material/Box";

import { startAnimation } from "./droneAnimation.js"
import { useEffect } from "react";

import Lenis from '@studio-freight/lenis';
import "splitting/dist/splitting-cells.css";
import "splitting/dist/splitting.css";
import Section1 from "./Component/Section1.jsx";
import Section5 from "./Component/Section5.jsx";
import Section2 from "./Component/Section2.jsx";
import Section3 from "./Component/Section3.jsx";
import Section4 from "./Component/Section4.jsx";

const App = () => {
	useEffect(() => {
		startAnimation();
	}, [])
	useEffect(() => {

		const lenis = new Lenis({
			duration: 1.9,
			easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
			direction: "vertical",
			gestureDirection: "vertical",
			smooth: true,
			smoothTouch: false,
		});

		function raf(time) {
			lenis.raf(time);
			requestAnimationFrame(raf);
		}

		requestAnimationFrame(raf);


	}, [])

	return (
		<>
			<h1 className="subtitle" id="target">DRONE DESTINATION</h1>

			<Box sx={{ zIndex: 10, position: "relative" }}>
				<Section1 />
				<Section5 />
				<Section2 />
				<Section3 />
				<Section4 />

			</Box>
		</>
	);
}

export default App;
